import { Center } from '../Center'
import { Zoom } from '../Zoom'
import { MaxBounds } from '../MaxBounds'
import { Pitch } from '../Pitch'
import { useContext } from 'react'
import { MapContext } from 'components/Mapbox/Mapbox'

export const View = ({
  center,
  zoom,
  maxBounds,
  pitch,
  minZoom,
}: {
  center?: { lat: number; lng: number }

  zoom?: number
  minZoom?: number

  maxBounds?:
    | {
        desktop?: [[number, number], [number, number]]
        mobile?: [[number, number], [number, number]]
      }
    | [[number, number], [number, number]]

  pitch?: number
}) => {
  var maxBoundsDesktop
  var maxBoundsMobile
  if (maxBounds) {
    maxBoundsDesktop = Array.isArray(maxBounds) ? maxBounds : maxBounds?.desktop
    maxBoundsMobile = Array.isArray(maxBounds) ? maxBounds : maxBounds?.mobile
  }

  return (
    <>
      {center && <Center lng={center.lng} lat={center.lat} />}

      {zoom && <Zoom zoom={zoom} minZoom={minZoom} />}

      {maxBoundsDesktop && maxBoundsMobile && (
        <MaxBounds
          boundsDesktop={maxBoundsDesktop}
          boundsMobile={maxBoundsMobile}
        />
      )}

      {pitch && <Pitch pitch={50} />}
    </>
  )
}
